import { API_BASE_URL } from "@/config";
import Swal from "sweetalert2";
import GetQuestions from "@/components/GetQuestions/GetQuestions.vue";
import { handle_registration_redirect } from "@/utils/redirects";
import TermsModal from "@/components/Terms/TermsModal.vue";
import MarketingConsentModal from "@/components/MarketingConsent/MarketingConsentModal.vue";
import { useToast } from "@/components/Toast/useToast";
import PhoneInput from "@/components/PhoneInput/PhoneInput.vue";

export default {
  name: "UserRegistration",
  components: {
    GetQuestions,
    TermsModal,
    MarketingConsentModal,
    PhoneInput,
  },

  setup() {
    const { showSuccess, showError } = useToast();

    return {
      showSuccess,
      showError,
    };
  },
  data() {
    return {
      first_name: "",
      last_name: "",
      email: "",
      phone_number: "",
      password: "",
      confirm_password: "",
      show_password: false,
      show_confirm_password: false,
      client_admin_id: sessionStorage.getItem("client_admin_id"),
      responses: [],
      follow_up_responses: [],
      password_strength: "",
      password_field_active: false,
      acceptTerms: false,
      acceptMarketing: false,
      clientName: "",
      client: "",
      updatingConsent: false,
      prefer_phone_number: false,
      requirements: {
        lowercase: false,
        uppercase: false,
        numeric: false,
        length: false,
        special: false,
      },
    };
  },

  created() {
    const domain = window.location.hostname;

    if (domain.includes("verify")) {
      this.client = "verify";
      this.clientName = "Verify";
    } else if (domain.includes("wizzit")) {
      this.client = "wizzit";
      this.clientName = "Wizzit";
    } else if (domain.includes("mobiafrica")) {
      this.client = "mobiafrica";
      this.clientName = "Mobi Africa";
    } else if (domain.includes("vodacom")) {
      this.client = "vodacom";
      this.clientName = "Vodacom";
    } else if (domain.includes("weelee")) {
      this.client = "weelee";
      this.clientName = "Weelee";
    } else if (domain.includes("nutun")) {
      this.client = "nutun";
      this.clientName = "Nutun";
    } else if (domain.includes("nurturelink")) {
      this.client = "nurturelink";
      this.clientName = "Nurture Link";
    } else if (domain.includes("suzuki")) {
      this.client = "suzuki";
      this.clientName = "Suzuki Bassonia";
    } else if (domain.includes("veersgroup")) {
      this.client = "veersgroup";
      this.clientName = "Veers Group";
    } else if (domain.includes("eaglecorner")) {
      this.client = "eaglecorner";
      this.clientName = "Eagle Corner";
    } else if (domain.includes("hybridconcepts")) {
      this.client = "hybridconcepts";
      this.clientName = "Hybrid Concepts";
    } else if (domain.includes("eeb")) {
      this.client = "eeb";
      this.clientName = "Essential Employee Benefits";
    } else if (domain.includes("miway")) {
      this.client = "miway";
      this.clientName = "MiWay";
    } else if (domain.includes("mfo")) {
      this.client = "mfo";
      this.clientName = "MFO";
    } else if (domain.includes("ittsc")) {
      this.client = "ittsc";
      this.clientName = "ITTSC";
    } else if (domain.includes("smartsure")) {
      this.client = "smartsure";
      this.clientName = "SmartSure";
    } else if (domain.includes("experian")) {
      this.client = "experian";
      this.clientName = "Experian";
    } else if (domain.includes("autocity")) {
      this.client = "autocity";
      this.clientName = "Auto City";
    } else if (domain.includes("yumbi")) {
      this.client = "yumbi";
      this.clientName = "Yumbi";
    } else if (domain.includes("santam")) {
      this.client = "santam";
      this.clientName = "Santam";
    } else if (domain.includes("altron")) {
      this.client = "altron";
      this.clientName = "Altron";
    } else if (domain.includes("swift")) {
      this.client = "swift";
      this.clientName = "Swift";
    } else if (domain.includes("webuycars")) {
      this.client = "webuycars";
      this.clientName = "We Buy Cars";
    } else if (domain.includes("neutrinori")) {
      this.client = "neutrinori";
      this.clientName = "Neutrinori";
    } else if (domain.includes("getsavvi")) {
      this.client = "getsavvi";
      this.clientName = "GetSavvi";
    }
  },

  computed: {
    phoneCountries() {
      return this.$store.getters.get_branding?.phone_countries || [];
    },
    strength_bar_class() {
      return {
        weak: this.password_strength === "Weak",
        medium: this.password_strength === "Medium",
        strong: this.password_strength === "Strong",
      };
    },

    strength_text_class() {
      return {
        "text-danger": this.password_strength === "Weak",
        "text-warning": this.password_strength === "Medium",
        "text-success": this.password_strength === "Strong",
      };
    },
    passwords_match() {
      return this.password === this.confirm_password;
    },
  },

  mounted() {
    const get_client_id = sessionStorage.getItem("client_admin_id");
    const token = localStorage.getItem("token");
    const user_id = localStorage.getItem("user_id");

    const asset_id = sessionStorage.getItem("asset_id");

    if (asset_id) {
      this.check_asset_status(asset_id);
    }

    if (token && user_id) {
      this.check_and_redirect(token, get_client_id);
    }
  },

  beforeDestroy() {
    if (this.error_timeout) {
      clearTimeout(this.error_timeout);
    }
  },

  methods: {
    save_client_admin_terms_after_registration(client_admin_id, is_confirmed) {
      const base_url = API_BASE_URL;
      const SAVE_URL = `${base_url}/verify_api/customer_management_api/save_client_admin_terms_and_conditions/`;
      const TOKEN = localStorage.getItem("token");

      return new Promise((resolve) => {
        $.ajax({
          url: SAVE_URL,
          method: "POST",
          contentType: "application/json",
          headers: { Authorization: `Token ${TOKEN}` },
          data: JSON.stringify({
            client_admin_id: client_admin_id,
            is_confirmed: is_confirmed,
          }),
          success: (resp) => {
            resolve(resp);
          },
          error: (err) => {
            console.error("Error saving client admin terms:", err);
            resolve(err);
          },
        });
      });
    },

    toggle_registration_method() {
      if (this.prefer_phone_number) {
        this.email = "";
        $(
          ".email-message, .email-exists-message, .email-error-message",
        ).addClass("d-none");
      } else {
        this.phone_number = "";
        if (this.$refs.phoneInput) {
          this.$refs.phoneInput.hideErrors();
        }
      }
    },

    getTermsContent() {
      return this.$refs.termsModal?.getContent() || "";
    },

    getMarketingContent() {
      return this.$refs.marketingConsentModal?.getContent() || "";
    },

    getFormattedPhoneNumber() {
      if (this.$refs.phoneInput) {
        const fullNumber = this.$refs.phoneInput.getFullNumber();
        const instance = this.$refs.phoneInput.getInstance();

        // For South Africa, convert +27 format back to 0 prefix
        if (instance) {
          const countryData = instance.getSelectedCountryData();
          if (countryData.iso2 === 'za' && fullNumber.startsWith('+27')) {
            return '0' + fullNumber.substring(3).replace(/\\s/g, '');
          }
        }

        return fullNumber.replace(/\\s/g, '');
      }
      return this.phone_number;
    },

    validatePhoneNumber() {
      return this.$refs.phoneInput?.validate() ?? false;
    },

    showPhoneExistsError() {
      this.$refs.phoneInput?.showExistsError();
    },

    check_asset_status(asset_id) {
      const check_asset_status_url = `${API_BASE_URL}/verify_api/system_management_api/check_asset_status/`;
      sessionStorage.setItem("asset_id", asset_id);

      fetch(`${check_asset_status_url}?asset_id=${asset_id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (!data.is_active) {
            this.$router.push({
              name: "asset_deactive",
            });
          }
        });
    },

    show_error(selector, message, duration = 3000) {
      const $element = $(selector);
      $element.text(message).removeClass("d-none").show();
      if (this.error_timeout) {
        clearTimeout(this.error_timeout);
      }
      this.error_timeout = setTimeout(() => {
        $element.addClass("d-none");
      }, duration);
    },

    openTermsModal() {
      if (this.$refs.termsModal) {
        this.$refs.termsModal.showModal = true;
      }
    },

    openMarketingModal() {
      if (this.$refs.marketingConsentModal) {
        this.$refs.marketingConsentModal.showModal = true;
      }
    },

    handleTermsAccept() {
      this.acceptTerms = true; // Only update terms checkbox
    },

    handleTermsDecline() {
      this.acceptTerms = false; // Only update terms checkbox
    },

    handleMarketingAccept() {
      this.acceptMarketing = true; // Only update marketing checkbox
    },
    handleMarketingDecline() {
      this.acceptMarketing = false; // Only update marketing checkbox
    },
    async update_customer_consent(consentType, isAccepted) {
      if (this.updatingConsent) return;

      const user_id = localStorage.getItem("user_id");
      if (!user_id) return;

      this.updatingConsent = true;
      const consent_type_id = consentType === "indemnity" ? 6 : 5;

      try {
        await $.ajax({
          type: "POST",
          url: `${API_BASE_URL}/verify_api/system_management_api/update_consent/`,
          data: JSON.stringify({
            user_id: user_id,
            consent_type_id: consent_type_id,
            consent_provided: isAccepted,
          }),
          contentType: "application/json",
          headers: {
            Authorization: `Token ${localStorage.getItem("token")}`,
          },
        });

        // Update local state
        if (consentType === "indemnity") {
          this.acceptTerms = isAccepted;
        } else {
          this.acceptMarketing = isAccepted;
        }
      } catch (error) {
        // Show error message to user
        this.showError("Error updating consent. Please try again.");
      } finally {
        this.updatingConsent = false;
      }
    },

    validate_password() {
      const requirements = {
        lowercase: {
          test: /[a-z]/.test(this.password),
          message: "Include lowercase letter",
        },
        uppercase: {
          test: /[A-Z]/.test(this.password),
          message: "Include uppercase letter",
        },
        numeric: {
          test: /[0-9]/.test(this.password),
          message: "Include number",
        },
        special: {
          test: /[!@#$%^&*]/.test(this.password),
          message: "Include special character",
        },
        length: {
          test: this.password.length >= 8,
          message: "Minimum 8 characters",
        },
      };

      for (const [key, value] of Object.entries(requirements)) {
        this.requirements[key] = value.test;
        if (!value.test) {
          this.show_error(".password-requirements-message", value.message);
          return false;
        }
        this.requirements[key] = value.test;
      }
      return true;
    },

    toggle_password_view() {
      this.show_password = !this.show_password;
    },

    toggle_confirm_password_view() {
      this.show_confirm_password = !this.show_confirm_password;
    },

    convert_email_to_lowercase() {
      if (this.email) {
        this.email = this.email.toLowerCase();
      }
    },

    check_and_redirect(token, get_client_id) {
      const check_process_url = `${API_BASE_URL}/verify_api/system_management_api/user_redirect_api/`;

      $.ajax({
        url: check_process_url,
        method: "GET",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${token}`,
        },
        success: (response) => {
          handle_registration_redirect(
            response,
            this.$router,
            this.$store,
            this.fetch_current_service,
            get_client_id,
          );
        },
        error: () => {
          Swal.close();
          this.showError("Session expired. Please log in again.");
        },
      });
    },

    check_password_strength() {
      this.validate_password();
      const met_requirements = Object.values(this.requirements).filter(
        Boolean,
      ).length;

      if (met_requirements <= 2) {
        this.password_strength = "Weak";
      } else if (met_requirements <= 4) {
        this.password_strength = "Medium";
      } else {
        this.password_strength = "Strong";
      }
    },

    password_match() {
      const matches = this.password === this.confirm_password;
      if (!matches) {
        this.show_error(".match-password-message", "Passwords do not match");
      }
      this.check_password_strength();
      return matches;
    },

    validate_name(field_name) {
      let input_value = this[field_name];
      input_value = input_value.replace(/[^a-zA-Z\s]/g, "");
      input_value = input_value
        .split(" ")
        .filter((word) => word.length > 0)
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
        )
        .join(" ");
      this[field_name] = input_value;
    },

    store_responses(dynamic_fields, follow_up_responses = []) {
      this.responses = dynamic_fields;
      this.follow_up_responses = follow_up_responses;
    },

    validate_inputs() {
      const validations = [
        {
          condition: !this.first_name.trim(),
          selector: ".first-name-message",
          message: "Please fill in your first name",
        },
        {
          condition: !this.last_name.trim(),
          selector: ".last-name-message",
          message: "Please fill in your last name",
        },
        {
          condition: !this.password.trim(),
          selector: ".password-message",
          message: "Please create your own password",
        },
        {
          condition: !this.confirm_password.trim(),
          selector: ".confirm-pswd-message",
          message: "Please confirm your password",
        },
      ];

      if (this.client === "verify" && !this.prefer_phone_number) {
        // Email registration - only validate email
        validations.push({
          condition: !this.email.trim(),
          selector: ".email-message",
          message: "Please fill in your email address",
        });
      } else if (this.client !== "verify") {
        validations.push({
          condition: !this.email.trim(),
          selector: ".email-message",
          message: "Please fill in your email address",
        });
      }
      // Phone validation is handled by PhoneInput.validate() below

      for (const validation of validations) {
        if (validation.condition) {
          this.show_error(validation.selector, validation.message);

          return false;
        }
      }

      if (!this.validate_password()) {
        return false;
      }

      if (!this.password_match()) {
        return false;
      }

      if (!(this.client === "verify" && this.prefer_phone_number)) {
        if (
          !this.email.trim() ||
          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)
        ) {
          this.show_error('.email-error-message', 'Please enter a valid email address');
          return false;
        }
      }

      if (!(this.client === "verify" && !this.prefer_phone_number)) {
        if (!this.validatePhoneNumber()) {
          return false;
        }
      }

      return true;
    },

    handle_register() {
      if (this.validate_inputs()) {
        const client_admin_id = sessionStorage.getItem("client_admin_id");
        const customer_application = sessionStorage.getItem(
          "customer_application",
        );
        if (
          (client_admin_id && client_admin_id !== "null") ||
          (customer_application && customer_application !== "null")
        ) {
          this.user_registration();
        } else {
          this.$router.push({ name: "invalid_link" });
        }
      }
    },

    process_responses() {
      let processed_responses = [];

      this.responses.forEach((field) => {
        if (field.has_file && field.value instanceof File) {
          processed_responses.push({
            service_id: field.service_id,
            question_id: field.question_id,
            value: field.value.name,
            uploaded_file: field.value,
          });
        } else {
          processed_responses.push({
            question_id: field.question_id,
            value: field.value,
          });
        }
        const follow_ups = this.follow_up_responses.filter(
          (follow_up) => follow_up.parent_id === field.question_id,
        );

        if (follow_ups.length > 0) {
          follow_ups.forEach((follow_up) => {
            if (follow_up.has_file && follow_up.value instanceof File) {
              processed_responses.push({
                question_id: follow_up.question_id,
                value: follow_up.value.name,
                uploaded_file: follow_up.value,
              });
            } else {
              processed_responses.push({
                question_id: follow_up.question_id,
                value: follow_up.value,
              });
            }
            // If the follow-up contains a file, push it separately
          });
        }
      });
      return processed_responses;
    },

    handle_registration_error(xhr, error_data) {
      Swal.close();

      // Clear any existing error messages
      $(
        ".email-exists-message, .email-error-message, .error-message",
      ).addClass("d-none");
      if (this.$refs.phoneInput) {
        this.$refs.phoneInput.hideErrors();
      }
      if (error_data) {
        if (error_data.email_exists_error) {
          this.show_error(
            ".email-exists-message",
            error_data.email_exists_error,
          );
        } else if (error_data.phone_number_exists_error) {
          this.showPhoneExistsError();
        } else if (error_data.email) {
          if (typeof error_data.email === "string") {
            this.show_error(".email-error-message", error_data.email);
          } else if (Array.isArray(error_data.email)) {
            this.show_error(".email-error-message", error_data.email[0]);
          }
        } else if (error_data.error) {
          this.show_error(".error-message", error_data.error);
        } else {
          this.show_error(
            ".error-message",
            "An error occurred during registration.",
          );
        }
      }
    },
    handle_registration_success(response) {
      Swal.close();
      localStorage.setItem("user_id", response.user_id);
      localStorage.setItem("token", response.token);
      this.$store.commit("set_user_role", response.user_role);
      this.$router.push("/user_otp");
    },

    user_registration() {
      if (
        !this.validate_inputs() ||
        !this.passwords_match ||
        !this.$refs.get_questions.validate_form() ||
        this.handle_registration_error()
      ) {
        return;
      }

      const get_client_id = sessionStorage.getItem("client_admin_id");
      const customer_application = sessionStorage.getItem(
        "customer_application",
      );
      const get_asset_id = sessionStorage.getItem("asset_id");
      const get_workflow_id = sessionStorage.getItem("workflow_id");
      const base_url = API_BASE_URL;
      const customer_registration_url = `${base_url}/verify_api/system_management_api/register_customer_api/`;

      const all_responses = this.process_responses();
      const has_file = this.responses.some((field) => field.has_file);

      const terms_content = this.getTermsContent();
      const marketing_content = this.getMarketingContent();

      let data_to_send;
      let content_type = "application/json";
      let process_data = true;

      const form_data_obj = new FormData();

      if (has_file) {
        form_data_obj.append("client_admin_id", get_client_id);
        form_data_obj.append("customer_application", customer_application);
        form_data_obj.append("first_name", this.first_name);
        form_data_obj.append("last_name", this.last_name);
        form_data_obj.append("email", this.email);
        form_data_obj.append("phone_number", this.phone_number);
        form_data_obj.append("password", this.password);
        form_data_obj.append("confirm_password", this.confirm_password);
        form_data_obj.append("workflow_id", get_workflow_id);
        form_data_obj.append("accept_terms", JSON.stringify(this.acceptTerms));
        form_data_obj.append(
          "accept_marketing",
          JSON.stringify(this.acceptMarketing),
        );

        // Add the actual terms content
        form_data_obj.append("terms_content", terms_content);
        form_data_obj.append("marketing_content", marketing_content);

        if (this.client === "verify" && this.prefer_phone_number) {
          form_data_obj.append("phone_number", this.getFormattedPhoneNumber());
          form_data_obj.append("email", this.phone_number + "@tgpdc.com");
        } else {
          form_data_obj.append("phone_number", this.getFormattedPhoneNumber());
          form_data_obj.append("email", this.email);
        }

        all_responses.forEach((response, index) => {
          form_data_obj.append(
            `responses[${index}][question_id]`,
            response.question_id,
          );
          form_data_obj.append(`responses[${index}][value]`, response.value);

          if (response.service_id) {
            form_data_obj.append(
              `responses[${index}][service_id]`,
              response.service_id,
            );
          }
          if (response.uploaded_file) {
            form_data_obj.append(
              `responses[${index}][uploaded_file]`,
              response.uploaded_file,
            );
          }
        });

        data_to_send = form_data_obj;
        content_type = false;
        process_data = false;
      } else {
        const json_data = {
          client_admin_id: get_client_id,
          customer_application: customer_application,
          asset_id: get_asset_id,
          workflow_id: get_workflow_id,
          first_name: this.first_name,
          last_name: this.last_name,
          password: this.password,
          confirm_password: this.confirm_password,
          responses: all_responses,
          consents: [
            {
              consent_type_id: 6,
              consent_provided: this.acceptTerms,
            },
            {
              consent_type_id: 5,
              consent_provided: this.acceptMarketing,
            },
          ],

          accept_terms: this.acceptTerms,
          accept_marketing: this.acceptMarketing,

          terms_content: terms_content,
          marketing_content: marketing_content,
        };

        if (this.client === "verify" && this.prefer_phone_number) {
          json_data.phone_number = this.getFormattedPhoneNumber();
          json_data.email = this.phone_number + "@tgpdc.com";
        } else {
          json_data.phone_number = this.getFormattedPhoneNumber();
          json_data.email = this.email;
        }
        data_to_send = JSON.stringify(json_data);
      }

      $.ajax({
        method: "POST",
        url: customer_registration_url,
        data: data_to_send,
        processData: process_data,
        contentType: content_type,
        dataType: "json",
        beforeSend: () => {
          Swal.fire({
            text: "Loading ...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              Swal.showLoading();
            },
          });
        },
        success: this.handle_registration_success,
        error: (xhr) => {
          let error_data;
          try {
            // Try to parse the response as JSON
            error_data =
              xhr.responseJSON ||
              (xhr.responseText ? JSON.parse(xhr.responseText) : null);
          } catch (e) {
            // If parsing fails, create a generic error object
            error_data = null;
          }
          this.handle_registration_error(xhr, error_data);
        },
      });
    },
  },
};
